const dataFilterSmallLarge = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.5 3v9.4"/><polyline points="1 9.86 3.53 13 6 9.92"/><path d="M7.31 11.61H15"/><path d="M7.31 7.88h6.59"/><path d="M7.31 4.15h5.49"/></svg>',
};

export { dataFilterSmallLarge as default };
